class SampleHandler extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.sections = this.onCartPage
      ? window.BAO.sectionRenderer.cartSections
      : window.BAO.sectionRenderer.pushCartSections
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.init.bind(this),
    )
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.init.bind(this),
    )
  }

  async init () {
    this.data = await this.fetchData()

    if (this.data.is_cart_empty) {
      return
    }

    await this.removeSamples()
  }

  async removeSamples () {
    const sampleKeys = new Set()
    const onlyContainsSamples = this.data?.cartData?.items?.every(item => {
      const isSample = (item.product_type || '').toLowerCase() === 'sample'
      if (isSample) {
        sampleKeys.add(item.key)
      }
      return isSample
    })

    const uniqueSampleKeys = [...sampleKeys]

    if (!uniqueSampleKeys.length || !onlyContainsSamples) return

    const state = await window.BAO.Cart.removeItems(uniqueSampleKeys, {
      sections: this.mappedSections,
      silent: false,
    })

    if (!state) return

    if ('sections' in state) this.renderCartSections(state.sections)
  }

  async fetchData () {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const cartData = await response.json()

      return {
        cartData,
      }
    } catch (err) {
      console.error(err)
    }
  }

  renderCartSections (sections) {
    if (!this.onCartPage) return

    const sectionsToRender = this.sections
      .map(section => {
        const sectionToRender = sections[section.section]

        if (!sectionToRender) return null

        return {
          ...section,
          html: sections[section.section],
        }
      })
      .filter(Boolean)

    window.BAO.sectionRenderer.renderMultiple(sectionsToRender)
  }

  get mappedSections () {
    return this.sections.map(s => s.section)
  }
}

if (!customElements.get('sample-handler')) {
  customElements.define('sample-handler', SampleHandler)
}
